export const RECAPTCHA_SITE_KEY = '6Lcug4waAAAAAAaKrIj0VQRvQMbQhhalzVl6uswq'

const LOAD_TIMEOUT = 5000

/** Injects the reCAPTCHA v3 script once and resolves when grecaptcha is ready */
export const waitRecaptcha = async (): Promise<void> => {
  const exists = window.document.head.querySelector('[data-recaptcha]')
  if (!exists) {
    const tag = window.document.createElement('script')
    tag.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`
    tag.async = true
    window.document.head.appendChild(tag)
    let waitTimeout: ReturnType<typeof setTimeout> | undefined
    let waitInterval: ReturnType<typeof setInterval> | undefined
    await Promise.race([
      new Promise<void>((_resolve, reject) => {
        waitTimeout = setTimeout(() => {
          clearInterval(waitInterval)
          reject(new Error('timeout loading'))
        }, LOAD_TIMEOUT)
      }),
      new Promise<void>((resolve) => {
        waitInterval = setInterval(() => {
          if (window.grecaptcha) {
            clearTimeout(waitTimeout)
            clearInterval(waitInterval)
            resolve()
          }
        }, 50)
      }),
    ])
  }
  return new Promise((resolve) => {
    window.grecaptcha!.ready(resolve)
  })
}

export const getRecaptchaToken = async (action: string): Promise<string> => {
  await waitRecaptcha()
  return window.grecaptcha!.execute(RECAPTCHA_SITE_KEY, { action })
}
